import { Avatar, theme } from 'antd'
import { initials } from '@/Ship/Helpers/fieldViews'

import type { CSSProperties, ReactNode } from 'react'

interface ChatAvatarProps {
  /** Ім'я людини чи назва чату — з нього ініціали, коли фото немає */
  name: string
  src?: string | null | undefined
  size: number
  /** Іконка замість ініціалів — для групи */
  icon?: ReactNode
  /** Стоїть на блакитному тлі обраного рядка — коло на крок темніше, інакше зливається з ним */
  onTint?: boolean
  style?: CSSProperties
}

/**
 * Аватар у чаті: фото, а без нього — ініціали в тоні застосунку.
 *
 * Вигляд той самий, що в картках (`UserChip`, журнал змін, картка
 * співробітника): блакитне тло, синій напис, дві літери. Сірий кружок з однією
 * літерою читався як заглушка, і та сама людина в чаті й у картці виглядала
 * по-різному.
 */
const ChatAvatar = ({ name, src, size, icon, onTint = false, style }: ChatAvatarProps) => {
  const { token } = theme.useToken()

  if (src) {
    return <Avatar src={src} size={size} style={{ flexShrink: 0, ...style }} />
  }

  return (
    <Avatar
      size={size}
      {...(icon ? { icon } : {})}
      style={{
        background: onTint ? token.colorPrimaryBgHover : token.colorPrimaryBg,
        color: token.colorPrimary,
        flexShrink: 0,
        // Розмір літер задаємо самі: інакше antd стискає їх transform'ом
        ...(icon ? {} : { fontSize: Math.max(9, Math.round(size * 0.4)) }),
        ...style,
      }}
    >
      {icon ? null : initials(name) || '?'}
    </Avatar>
  )
}

export default ChatAvatar
